import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, colors, TextField } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "../CheckBoxComponent";
import DiscountPermissions from "../discount-permissions";
import { Autocomplete } from "@material-ui/lab";
import { useStylesTF, useStylesLbl,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import { GetItemFromOptions } from "../../../../services/global-services";
import moment from "moment";
import { reFormatDate } from "../../../../utils/utils";
const formData = [
    {
        name: "use_lock_date",
        label: "تفعيل اقفال الفترات الضريبية",
        visible: true,
    },
];

export default function OtherSettings(props) {
    const { onChange, object, update, sub,AutoOptions } = props;

    const classes = useStylesAcc();
    const clasTF = useStylesTF();
    const clasASafe = useStylesAutoSafe();
    const claslbl = useStylesLbl();

    const valuebranch = GetItemFromOptions(object?.branch??1,AutoOptions.Branches??[]);
  
    return (
        <div className={classes.root}>
            <Accordion expanded={true}>
                <AccordionDetails className={classes.subTitle}>
                    {" "}
                </AccordionDetails>

                <AccordionDetails >
                    <Grid item container spacing={1}>
                        {formData
                            ?.filter((d) => d.visible)
                            ?.map((item) => {
                                // console.log(object);
                                return (
                                    <Grid xs={6}>
                                        <CheckboxItem
                                            value={object[item.name] ?? null}
                                            name={item.name}
                                            label={item.label}
                                            onChange={onChange}
                                        />
                                    </Grid>
                                );
                            })}
                    </Grid>
                </AccordionDetails>

                <AccordionDetails>
                    {" "}
                    {/* <Typography> {"برجاء تحدي الفتر"} */}

                    {/* </Typography>{" "} */}


                </AccordionDetails>

                <AccordionDetails style={{ backgroundColor: colors.grey[50] }}>
                    {object?.use_lock_date ?
                        (
                            <Grid container style={{ padding: 5 }} spacing={1}>

                                <Grid item lg={2} md={2} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small" id="Start_Lock_Date"
                                        label="من تاريخ"
                                        className={clasTF.rootSafe}
                                        InputProps={{ className: claslbl.clrBlackTxt }}
                                        type="date" format="YYYY-MM-DD"
                                        name="Start_Lock_Date"
                                        value={object?.Start_Lock_Date ?? moment("1999-01-01").format("YYYY-MM-DD")}
                                        //onChange={onChange('Start_Lock_Date')}
                                        onChange={(event, newValue) => {
                                            onChange(null, {
                                                name: "Start_Lock_Date",
                                                value: event.target.value,
                                            });
                                        }}
                                    /></Grid>

                                <Grid item lg={2} md={2} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small"
                                        id="End_Lock_Date" label="إلى تاريخ"
                                        className={clasTF.rootSafe}
                                        InputProps={{ className: claslbl.clrBlackTxt }}
                                        type="date" format="YYYY-MM-DD"
                                        name="End_Lock_Date" value={object?.End_Lock_Date ?? moment("1999-01-01").format("YYYY-MM-DD")}
                                        //onChange={onChange('End_Lock_Date')}
                                        onChange={(event, newValue) => {
                                            onChange(null, {
                                                name: "End_Lock_Date",
                                                value: event.target.value,
                                            });
                                        }}
                                    /></Grid>
                                <Grid item xs={2} lg={4} md={4} sm={12}>
                                    <Autocomplete
                                        value={valuebranch}
                                        onChange={(event, newValue) => {
                                            onChange(null, {
                                                name: "branch",
                                                value: newValue,
                                            });
                                            onChange(null, {
                                                name: "End_Lock_Date",
                                                value: reFormatDate(valuebranch.End_Lock_Date??"1999-01-01"),
                                            });
                                            onChange(null, {
                                                name: "Start_Lock_Date",
                                                value: reFormatDate(valuebranch.Start_Lock_Date??"1999-01-01"),
                                            });
                                        }}
                                        id="apply_discount"
                                        size="small"
                                        options={AutoOptions.Branches}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        style={{}}
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                InputLabelProps={{ shrink: true }}
                                                label="الفرع"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        ) :
                        <Typography variant="h5" style={{ textAlign: "center" }}>
                            {/* <br />   */}
                            {/* {"\n this settings don't work if past discount allowed attribute doesn't enables"} */}
                            {"\n تاكد من تفعيل خيار تفعيل اقفال الفترات الضريبية  حتى يتم عرض الخيارات"}

                        </Typography>}
                </AccordionDetails>
                <Divider className={classes.divider} />
                <AccordionDetails className={classes.subTitle}>
                    {" "}
                    <Typography>
                        {" "}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            disabled={props.submitting}
                            onClick={update}
                        >
                            {"حفظ التعديلات"}
                        </Button>
                    </Typography>{" "}
                </AccordionDetails>
            </Accordion>
            <Swipeable />
        </div>
    );
}
